import AzureInstance from './AzureInstance';

const graphScopes = [process.env.VUE_APP_aad_api_scope];
const authority = process.env.VUE_APP_aad_authority;
/* eslint no-console: ["error", { allow: ["error","log"] }] */
export default {
  isLoggedIn() {
    return !!AzureInstance.getAccount();
  },

  async login() {
    //let request = {scopes : graphScopes, authority : authority };
    let request = { scopes : graphScopes };
    try {
      AzureInstance.handleRedirectCallback(function (error, response) {  //handle redirect response
        console.log(error, response);
      });
      await AzureInstance.loginRedirect(request);
      return true;
    } catch (err) {
      console.error(err);
      await AzureInstance.loginRedirect(request);
      return true;
    }
  },

  logOut() {
    AzureInstance.logout();
  },

  getUser() {
    const user = AzureInstance.getAccount();
    return user;
  },

  setUser() {
    const user = AzureInstance.getAccount();
    //return user != null && typeof user !== 'undefined' ? user : null;
    return (user) ? user : null;
  },

  async getToken() {
    if (window.Cypress) {
      return Promise.resolve(localStorage.getItem('msal.idtoken'));
    }
    let accessToken;
    let authResponse;
    let request = {scopes : graphScopes, authority : authority };
    try {
      authResponse = await AzureInstance.acquireTokenSilent(request);
    } catch (err) {
      console.error(err);
        authResponse = await AzureInstance.acquireTokenRedirect(request);
    }
    if(authResponse) {
      accessToken = authResponse.accessToken;
    }
    return accessToken;
  },
};
